module.exports = __webpack_public_path__ + "img/square-insta.89934f65.png";